import React, { useState } from "react";
import Loading from "../../images/loading.gif";

const ConfirmationPopup = ({ title, schedule, Cancel, isLoading }) => {
  return (
    <div
      className="modal_parent"
      id="deletesprint"
      // hidden={removeSprint}
    >
      <div className="module_popup deletePeople">
        <div
          className="module_innerpopup module_bodypop"
          style={{ background: "#fbfbfb" }}
        >
          <div className="module_headdiv">
            <h4 className="popup_head"> Please Confirm</h4>
          </div>
          <div className="module_body">
            {title === "Schedule" ? (
              <>
                <div className="py-3">
                  <div>Are you sure you want to schedule this interview?</div>
                  <div>
                    An email confirmation will be sent once the schedule is
                    confirmed.
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="module_body">
            {title === "OfferLetter" ? (
              <>
                <div className="py-3">
                  <div>Are you sure you want to send this offer letter</div>
                  <div>
                    An email confirmation will be sent once the offer is
                    confirmed.
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="button-wrapper text-end">
            {isLoading ? (
              <button className=" btn-btn btn btn-btn2 me-2" type="button">
                <img src={Loading} alt="loaderImg" width={20} height={20}></img>
              </button>
            ) : (
              <button
                type="submit"
                className=" btn-btn btn btn-btn1 me-2"
                onClick={() => schedule()}
              >
                Confirm
              </button>
            )}

            <button
              type="button"
              className=" btn-btn btn btn-btn2"
              onClick={() => Cancel()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
